import { render, staticRenderFns } from "./GlyRemoveDwxx.vue?vue&type=template&id=2840ddba&scoped=true&"
import script from "./GlyRemoveDwxx.vue?vue&type=script&lang=js&"
export * from "./GlyRemoveDwxx.vue?vue&type=script&lang=js&"
import style0 from "./GlyRemoveDwxx.vue?vue&type=style&index=0&id=2840ddba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840ddba",
  null
  
)

export default component.exports